var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.5H17.5V7C17.5 6.86737 17.4473 6.74023 17.3535 6.64642C17.2598 6.55267 17.1326 6.5 17 6.5H7C6.86743 6.5 6.74023 6.55267 6.64648 6.64642C6.55273 6.74023 6.5 6.86737 6.5 7V9.5Z",
    fill: "#ffffff",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7C6 7 6 6.58579 6.29289 6.29289C6.29289 6.29289 6.58579 6 7 6H17C17 6 17.4142 6 17.7071 6.29289C17.7071 6.29289 18 6.58579 18 7V17C18 17 18 17.4142 17.7071 17.7071C17.7071 17.7071 17.4142 18 17 18H7C7 18 6.58579 18 6.29289 17.7071C6.29289 17.7071 6 17.4142 6 17V7ZM7 7V17H17V7H7Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.5V7.5C14.5 7.77614 14.7239 8 15 8C15.2761 8 15.5 7.77614 15.5 7.5V5.5C15.5 5.22386 15.2761 5 15 5C14.7239 5 14.5 5.22386 14.5 5.5Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.5V7.5C8.5 7.77614 8.72386 8 9 8C9.27614 8 9.5 7.77614 9.5 7.5V5.5C9.5 5.22386 9.27614 5 9 5C8.72386 5 8.5 5.22386 8.5 5.5Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10H17.5C17.7761 10 18 9.77614 18 9.5C18 9.22386 17.7761 9 17.5 9H6.5C6.22386 9 6 9.22386 6 9.5C6 9.77614 6.22386 10 6.5 10Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3324 14.0619L10.0941 12.8872C10.0012 12.7991 9.87805 12.75 9.75 12.75L9.73682 12.7502C9.60426 12.7537 9.47851 12.8097 9.38725 12.9059C9.29913 12.9988 9.25 13.122 9.25 13.25L9.25017 13.2632C9.25367 13.3957 9.30968 13.5215 9.40589 13.6128L10.9871 15.1128C11.1796 15.2953 11.4811 15.2958 11.6741 15.1139L14.5929 12.3639C14.6894 12.273 14.7458 12.1474 14.7498 12.0149L14.75 12L14.7499 11.9909C14.7476 11.8666 14.6992 11.7476 14.6139 11.6571C14.5194 11.5568 14.3878 11.5 14.25 11.5L14.239 11.5001C14.1154 11.5028 13.9971 11.5513 13.9071 11.6361L11.3324 14.0619Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ab27d5513209cf225b8c786496543958.svg";
export { ForwardRef as ReactComponent };